<template>
    <div class="improvements-filters">
        <improvement-filter v-if="!scheme.hasFixedMotivation || !scheme.hasFixedBudget"
                            class="improvements-filters__filter improvements-filters__filter--recommended"
                            filter-key="recommended"
                            active-icon="fas fa-star" inactive-icon="far fa-star"
                            filter-text="recommended"
                            v-model="recommended">
            (<span v-if="!scheme.hasFixedMotivation">best <router-link v-if="motivationDisplay" class="improvements-filters__filter__back-link --motivation" :to="{ name: 'PlanChooser' }">
                {{ motivationDisplay }}</router-link> measures</span>&nbsp;<span v-if="!scheme.hasFixedBudget">for <router-link class="improvements-filters__filter__back-link --budget" :to="{ name: 'PlanChooser' }">
                {{ currentProject.budgetDisplay }}</router-link></span>)
        </improvement-filter>
        <improvement-filter class="improvements-filters__filter improvements-filters__filter--in-plan"
                            filter-key="in-plan"
                            active-icon="fas fa-check"
                            filter-text="your selections"
                            v-model="selected" />
        <category-filters class="improvements-filters__categories --mobile-only"
                          prefix="mobile" />
    </div>
</template>

<script>

import Vuex from 'vuex'

import PlanBuilderManager from '@/plan-builder-manager'

import Project from '@/models/project'

import AnalyticsLogger from '../analytics-logger'
import CategoryFilters from './category-filters'
import ImprovementFilter from './improvement-filter'
import ResourcesHelper from '@/components/resources-helper'

export default {

    mixins: [
        AnalyticsLogger,
        ResourcesHelper,
    ],

    computed: {
        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {Project}
             */
            currentProject: stateStore => Project.ensure(stateStore.improvements.currentProject),

            /**
             * @param {VuexState} stateStore
             * @returns {ImprovementsVuexStateFilters}
             */
            filters: stateStore => stateStore.improvements.improvementFilters,
        }),

        /**
         * @returns {string}
         */
        motivationDisplay() {
            const motivationResource = this.commonResources.motivations
                .find(mr => mr.key === this.currentProject.motivation)

            return motivationResource ? motivationResource.sentenceFragment : ''
        },

        /**
         * @returns {Scheme}
         */
        scheme() {
            return this.$scheme
        },

        recommended: {
            get() {
                return Boolean(this.filters.recommended)
            },
            set(value) {
                PlanBuilderManager.filterDisplayedImprovements('recommended', value)
                this.trackEvent('filter_measures', `filter_recommended_${ value ? 'on' : 'off' }`)
            },
        },

        selected: {
            get() {
                return Boolean(this.filters.selected)
            },
            set(value) {
                PlanBuilderManager.filterDisplayedImprovements('selected', value)
                this.trackEvent('filter_measures', `filter_selected_${ value ? 'on' : 'off' }`)
            },
        },
    },

    components: {
        CategoryFilters,
        ImprovementFilter,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-builder\_improvements-filters.scss

.improvements-filters {
    margin: 0.4rem 0;

    > * {
        margin-bottom: 0.5rem;
    }

    @include element('categories') {
        padding-top: rem(10px);
    }
}

</style>
